import axios from 'axios'
 
const request = axios.create({
    baseURL: ''
})
// function fnGetData(url)
// {
//     request.post(url,fnSetData())
//         .then(data => {
//             fnSetData(data)
//             if(typeof (data)=="object")
//             {
//                 Func(data, FuncPara);
//                 if(data.msg && data.msg.indexOf("身份失效")>0)
//                 {
//                     setTimeout(function(){
//                         location = "index.html?time=" + Date.parse(new Date());
//                     }, 800)
//                 }
//             }
//             else
//             {
//                 console.log("接口获取数据失败！","danger");
//             }
//         })
//         .catch(error => {
//             console.error('There was an error!', error);
//         });
// }
// 没有配置post/get  和 async
function fnGetData(url, senddata, timeout, Func, FuncPara)
{
    var time = Number(timeout) < 30000 ? 30000 : timeout;
    var returnstring = "";
    var contentType = typeof(senddata) === "object" ? "application/json; charset=utf-8" : "application/x-www-form-urlencoded; charset=UTF-8";
    // senddata = typeof(senddata) === "object" ? JSON.stringify(senddata) : senddata;
    request.post(url, senddata, {headers: {'Content-Type': contentType}, timeout: time})
        .then(data => {
            if(typeof (data)=="object")
            {
                Func(data, FuncPara);
            }
            else
            {
                console.log("接口获取数据失败！","danger");
            }
        })
        .catch(error => {
            // 正确处理axios错误对象
            if (error.code === 'ECONNABORTED') {
                returnstring = "err|timeout"; //连接超时
                console.log("连接超时，操作失败！","danger");
            } else if (error.response) {
                // 服务器返回了错误响应
                returnstring = `err|${error.response.status}`;
                console.log(`请求失败，状态码：${error.response.status}`,`danger`);
            } else if (error.request) {
                // 请求已发送但没有收到响应
                returnstring = "err|noresponse"; //无响应
                console.log("未收到服务器响应，操作失败！","danger");
            } else {
                // 请求配置错误
                returnstring = "err|config"; //配置错误
                console.log(`请求配置错误：${error.message}`,`danger`);
            }
            Func(returnstring);
        });
}

export default fnGetData